import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import { Card, CardContent, Divider } from '@mui/material';
import Language from '../../components/Language/Language';
import image from "../../images/graph.png"
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { CommonTextBox } from '../../components/TextBox';
import { Toolbar } from '@mui/material'
import { useTranslation } from 'react-i18next';
import { useResetPasswordMutation } from '../../store/api/authApi';
import { toast } from 'react-toastify';
import { useEffect } from 'react';

export default function ForgetPassword() {

    const { t } = useTranslation('login')
    const { t: l } = useTranslation('loginAndRegister')

    const navigate = useNavigate();
    const handleLogin = () => {
        navigate('/login')
    }
    const [email, setEmail] = useState('');

    const [postEmail] = useResetPasswordMutation()
    const handleReset = async () => {
        const data = await postEmail(email);
        if (data?.error) {
            toast.error(data?.error?.data?.errors?.email || "Error")
        }
        else {
            toast.success("Email sent")
            navigate('/reset-password')
        }
    }

    const contentForget = (
        <>
            <Box sx={{ display: "flex", aligntItems: "center", justifyContent: "space-between", mt: 2, mb: 1 }}>
                <Box sx={{ display: "flex", alignItems: "center", }}>
                    <Avatar sx={{ m: 1, backgroundColor: "#2196f3" }}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        {t("forgotPassword")}
                    </Typography>
                </Box>
                <Box>
                    <Language />
                </Box>
            </Box>

            <Toolbar />

            <Grid container display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                <Grid item xs={12} mt={2} mb={2}>
                    <CommonTextBox label={l("emailAddress")} value={email} id="email" setValue={setEmail} />
                </Grid>
            </Grid>


            <Grid container display="flex" alignContent="space-around" justifyContent="center" mt={2}>
                <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }} mt={4}>
                    <Button
                        type="submit"
                        variant="contained" s
                        sx={{ width: 250 }}
                        onClick={handleReset}
                    >
                        {l("sendEmail")}
                    </Button>
                </Grid>
            </Grid>
        </>
    )

    const contentText = (<>
        <img
            alt="Under development"
            src={image}
            style={{
                position: 'absolute',
                zIndex: -1,
                top: -250,
                left: -110,
                opacity: "10%",

            }}
        />
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: 150 }}>
            <Typography variant='h4' sx={{ color: "white" }}>Sola Soft</Typography>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: 150 }}>
            <Typography variant='subtitle1' sx={{ color: "white", textAlign: "center" }}>{l("slogan")}</Typography>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "flex-end", height: 100 }}>
            <Typography variant='subtitle1' sx={{ color: "white", textAlign: "center" }}></Typography>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "flex-end", height: 60 }}>
            <Button variant="outlined" sx={{ color: "white" }} onClick={handleLogin}>
                {l("loginName")}
            </Button>
        </Box>
    </>
    )

    return (


        <div className='animation-bg'>

            <Grid container width={{ xs: 400, sm: 400, md: 800 }}>
                <Grid item sx={{ display: { xs: "none", sm: "none", md: "block" }, }} md={4} lg={4} xl={4} >
                    <Card sx={{ zIndex: 2, position: "relative", backgroundColor: "#2196f3", height: 500 }} >
                        <CardContent>
                            {contentText}
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                    <Card sx={{ zIndex: 2, position: "relative", height: 500 }} >
                        <CardContent>
                            {contentForget}
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
            <div>
                <div className="wave"></div>
                <div className="wave"></div>
                <div className="wave"></div>
            </div>
        </div>
    );
}
